/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout/index'

const chatRouter = {
  path: '',
  component: Layout,
  redirect: '/home',
  name: 'Chat',
  meta: {
    title: 'router.chat-creation'
    // roles: ['user']
  },
  children: [
    {
      path: 'chat/:share_code?',
      component: () => import('@/views/chat/index.vue'), // Parent router-view
      name: 'ChatCreation',
      meta: {
        title: 'router.chat-creation'
        // roles: ['user.manage_user']
      }
    }
  ]
}
export default chatRouter
